export default __webpack_public_path__ + "static/media/login-visual6.1d7d9b1b.jpg";